"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyDeserializerHandle = exports.deserializeAsLegacy = exports.deserializeAsV1 = exports.isValidV1HtmlContent = exports.consolidateTextComponents = void 0;
const common_utils_1 = require("./utils/common-utils");
const v1_components_map_1 = require("./v1-components-map");
const legacy_components_map_1 = require("./legacy-components-map");
const consolidateTextComponents = (components) => components.reduce((combined, component) => {
    const previous = combined[combined.length - 1];
    if (component.type === 'text' && previous && previous.type === 'text') {
        previous.value.html += component.value.html;
    }
    else {
        combined.push(component);
    }
    return combined;
}, []);
exports.consolidateTextComponents = consolidateTextComponents;
const isValidV1HtmlContent = ($, html) => {
    try {
        const parsedComponents = (0, exports.deserializeAsV1)($, html);
        const reversedHtml = parsedComponents
            .map((component) => {
            const innerValue = (0, v1_components_map_1.v1ComponentsSerializationMap)($)[component.type].valueToHtml(component.value);
            return `<div data-component-type="${component.type}">${innerValue}</div>`;
        })
            .join('');
        const doubleParsedComponents = (0, exports.deserializeAsV1)($, reversedHtml);
        const $children = $('<div>').html(html).children();
        const componentCount = $children.filter('div[data-component-type]').length;
        const childrenCount = $children.length;
        const childrenCountMatch = childrenCount === parsedComponents.length;
        const componentCountMatch = componentCount === parsedComponents.length;
        const hasComponents = componentCount > 0;
        const componentContentMatch = (0, common_utils_1.deepEquals)(parsedComponents, doubleParsedComponents);
        return hasComponents && childrenCountMatch && componentCountMatch && componentContentMatch;
    }
    catch (_a) {
        return false;
    }
};
exports.isValidV1HtmlContent = isValidV1HtmlContent;
const deserializeAsV1 = ($, oldVersionedHtml) => $(oldVersionedHtml)
    .filter('div[data-component-type]')
    .toArray()
    .map((node) => {
    const $node = $(node);
    const type = $node.attr('data-component-type');
    const value = (0, v1_components_map_1.v1ComponentsSerializationMap)($)[type].htmlNodeToValue($node.contents());
    return { type, value };
});
exports.deserializeAsV1 = deserializeAsV1;
const deserializeAsLegacy = ($, oldVersionedHtml) => {
    const $node = $('<div class="dummy">').html(oldVersionedHtml);
    $node.find('iframe')
        .toArray()
        .reverse()
        .forEach((node) => {
        const $iframe = $(node);
        const $parent = $iframe.parent();
        if (!$parent.is('.dummy')) {
            $iframe.remove().insertAfter($parent);
        }
    });
    $node.find('.step-by-step-widget').each(function () {
        const $sbs = $(this);
        while (!$sbs.parent().is('.dummy')) {
            $sbs.parent().replaceWith($sbs);
        }
    });
    const components = $node
        .children()
        .toArray()
        .map((child) => {
        const $child = $(child);
        const innerVal = $('<div>').append($child.clone()).html();
        const result = {
            type: 'text',
            value: { html: innerVal },
        };
        let found = false;
        const legacyComponentsMap = (0, legacy_components_map_1.legacyComponentsMapCreator)($);
        Object.keys(legacyComponentsMap).forEach((type) => {
            const fn = legacyComponentsMap[type];
            const val = fn($child);
            if (found) {
                return;
            }
            if (val) {
                found = true;
                result.type = type;
                result.value = val;
            }
        });
        if (result.type === 'text') {
            const oldNoteContent = $node.find('.kb-note').html();
            $node.find('.kb-note').removeClass('kb-note').addClass('note').html('<i>' + oldNoteContent + '</i>');
            result.value.html = $('<div>').append($child.clone()).html();
        }
        return result;
    });
    return (0, exports.consolidateTextComponents)(components);
};
exports.deserializeAsLegacy = deserializeAsLegacy;
const legacyDeserializerHandle = ($) => (oldVersionedHtml, locale) => {
    const oldVersionedComponents = (0, exports.isValidV1HtmlContent)($, oldVersionedHtml)
        ? (0, exports.deserializeAsV1)($, oldVersionedHtml)
        : (0, exports.deserializeAsLegacy)($, oldVersionedHtml);
    const mapper = (0, v1_components_map_1.oldToNewComponentValueMap)(locale, $);
    return oldVersionedComponents.map((c) => mapper[c.type](c.value));
};
exports.legacyDeserializerHandle = legacyDeserializerHandle;
